/**
 * "Memory & knowledge" — Core Concepts (ADR-0074).
 * Reconciled from product/trust/privacy.md (memory model), product/architecture/
 * docs-rag.md, and the dashboard knowledge/docs connectors.
 */
import type { DocPageContent } from '../types';

export const MEMORY_PAGE: DocPageContent = {
  slug: 'memory',
  titleKey: 'docs.concepts.memory.title',
  descriptionKey: 'docs.concepts.memory.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.memory.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'memory-model',
      textKey: 'docs.concepts.memory.model.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.memory.model.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'knowledge',
      textKey: 'docs.concepts.memory.knowledge.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.memory.knowledge.body' },

    { kind: 'heading', level: 2, id: 'grounded', textKey: 'docs.concepts.memory.grounded.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.memory.grounded.body' },

    { kind: 'heading', level: 2, id: 'control', textKey: 'docs.concepts.memory.control.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.memory.control.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.concepts.memory.control.note.title',
      textKey: 'docs.concepts.memory.control.note.body',
      links: { trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' } },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.memory.next.catalog.title',
          textKey: 'docs.concepts.memory.next.catalog.text',
          to: { docSlug: 'catalog' },
        },
        {
          titleKey: 'docs.concepts.memory.next.quickstart.title',
          textKey: 'docs.concepts.memory.next.quickstart.text',
          to: { docSlug: 'quickstart' },
        },
      ],
    },
  ],
};
